export const desktopPickerPopoverShellClassName =
	'rounded-[20px] bg-[#292b2f] p-5 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.5)]';

export const desktopPickerPopoverWidthClassName = {
	party: 'w-[371px]',
	time: 'w-[371px]',
	calendar: 'w-[868px]'
} as const;

export const desktopPickerPopoverSideOffset = 36;

export const desktopPickerCalendarAlignOffset = -260;

export const desktopPickerPopoverContentClassName =
	'border-0 bg-transparent p-0 shadow-none outline-none';

export const desktopPickerScrollAreaClassName = 'max-h-[388px] overflow-y-auto p-1';

export const desktopPickerOptionBaseClassName =
	'flex w-full items-center justify-center rounded-2xl border border-white/10 bg-[#2f3238] font-poppins text-base font-semibold leading-none text-white/70 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] transition-colors hover:bg-[#3b3e44]';

export const desktopPickerOptionSelectedClassName =
	'border-2 border-[#1e2021] bg-[#3b3e44] text-white shadow-[0px_0px_0px_2px_rgba(255,255,255,0.5)] hover:bg-[#3b3e44]';

export const desktopPickerPartyOptionClassName =
	'h-[60px] min-h-[60px] shrink-0 py-3';

export const desktopPickerTimeOptionClassName = 'h-[52px] min-h-[52px] shrink-0';
